import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPreviewTrash = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.75 5.75V19.25C5.75 20.3546 6.64543 21.25 7.75 21.25H16.25C17.3546 21.25 18.25 20.3546 18.25 19.25V5.75M5.75 5.75H18.25M5.75 5.75H3.75M18.25 5.75H20.25M14 10.75V16.25M10 10.75V16.25M9 5.75C9 4.09315 10.3431 2.75 12 2.75C13.6569 2.75 15 4.09315 15 5.75"
    />
  </svg>
);
export default SvgPreviewTrash;
